import { styled } from 'styled-components';

import { LegacyButton } from '#/components/LegacyButton/LegacyButton';
import { colors } from '#/theme/theme';

export const TrashDeleteButton = styled(LegacyButton)<{
  $isBannerWithOverlay: boolean;
  $alignToCircle: boolean;
}>`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  ${(props) => {
    if (props.$isBannerWithOverlay) return `top: 20px; right: 20px;`;
    if (props.$alignToCircle) return 'top: 9%; right: 9%;';
    return `top: -13px; right: -13px;`;
  }}
  width: 25px;
  height: 25px;
  background-color: ${colors.brandBlue};
  color: white;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  transition: background-color 0.2s ease-in;

  &:hover {
    background-color: ${colors.brandGreen};
  }
`;
